// @flow

// $FlowFixMe we need to upgrade react redux flow typed
import { useSelector } from 'react-redux';

export default function useLoggedInUser() {
  const userImmutable = useSelector(state => state.user);
  const user = userImmutable.getIn(['data', '_embedded', 'user']);
  const adminHref = userImmutable.getIn(['data', '_links', 'admin', 'href']);

  return {
    isLoggedIn: !!user,
    isAdmin: !!adminHref,
    user: user?.toJS(),
  };
}
